/** 各フェーズ定義 */
export const PHASE = {
  // 車両情報取得開始
  START: 'start',
  // 注意表示
  CAUTION: 'caution',
  // ユニット不適合
  NONCONFORMITY: 'nonconformity',
  // READY ON確認
  READY_ON_CONFIRMATION: 'readyOnConfirmation',
  // 故障検出表示
  FAULT_DETECTION: 'faultDetection',
  // パーキングブレーキ解除確認
  RELEASE_PARKING_BRAKE: 'releaseParkingBrake',
  // ステアリング状態確認
  STEERING_CHK: 'steeringChk',
  // リフトアップ確認
  LIFT_UP_CHK: 'liftUpChk',
  // リヤデフ点検モード中断警告確認
  WARN_INTERRUPTION: 'warnInterruption',
  // VDC OFF確認
  VDC_OFF_CONFIRMATION: 'vdcOffConfirmation',
  // ブレーキペダル踏み込み指示
  PUSH_BRAKE: 'pushBrake',
  // Dレンジセレクト指示
  D_RANGE_SELECT: 'dRangeSelect',
  // ストップランプSW情報の取得
  STOP_LAMP_INFO: 'stopLampInfo',
  // 点検中
  UNDER_INSPECTION: 'underInspection',
  // 正常終了
  SUCCESS: 'success',
  // リヤデフ異常
  REAR_DIFF_ERROR: 'rearDiffError',
  // 異常終了
  INSPECTION_ERROR: 'inspectionError',
  // 車両停止指示
  STOP_VEHICLE: 'stopVehicle',
  // 終了指示
  FINISH_INSPECTION: 'finishInspection',
  // IG OFF指示
  IG_OFF: 'igOff',
  // タイムアウトエラー(中断確認なし)
  TIME_OUT_NOT_CHK: 'timeOutNotChk',
  // タイムアウトエラー(中断確認あり)
  TIME_OUT_CHK: 'timeOutChk',
  // 点検中断(エラー)
  CANCEL: 'cancel',
  // 異常終了(共通エラー)
  FAILED: 'failed',
};

const HEADER_COLORS = {
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
  SECONDARY: 'secondary'
};

const HEADER_TITLES = {
  CONFIRMATION: 'message.common_title_confirmation',
  EXECUTION: 'individual.common_title_execution',
  SUCCESS: 'message.common_title_success',
  WARNING: 'message.common_title_warning',
  ERROR: 'message.common_title_error'
};

// phase毎の情報
export const PHASE_INFO = {
  [PHASE.START]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION},
  [PHASE.CAUTION]: { headerColor: HEADER_COLORS.WARNING, headerTitle: HEADER_TITLES.WARNING},
  [PHASE.NONCONFORMITY]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR},
  [PHASE.READY_ON_CONFIRMATION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION},
  [PHASE.FAULT_DETECTION]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR},
  [PHASE.RELEASE_PARKING_BRAKE]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION},
  [PHASE.STEERING_CHK]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION},
  [PHASE.LIFT_UP_CHK]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION},
  [PHASE.WARN_INTERRUPTION]: { headerColor: HEADER_COLORS.WARNING, headerTitle: HEADER_TITLES.WARNING},
  [PHASE.VDC_OFF_CONFIRMATION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION},
  [PHASE.PUSH_BRAKE]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION},
  [PHASE.D_RANGE_SELECT]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION},
  [PHASE.STOP_LAMP_INFO]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION},
  [PHASE.UNDER_INSPECTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION},
  [PHASE.SUCCESS]: { headerColor: HEADER_COLORS.SUCCESS, headerTitle: HEADER_TITLES.SUCCESS},
  [PHASE.REAR_DIFF_ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR},
  [PHASE.INSPECTION_ERROR]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR},
  [PHASE.STOP_VEHICLE]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.EXECUTION},
  [PHASE.FINISH_INSPECTION]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION},
  [PHASE.IG_OFF]: { headerColor: HEADER_COLORS.SECONDARY, headerTitle: HEADER_TITLES.CONFIRMATION},
  [PHASE.TIME_OUT_NOT_CHK]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR},
  [PHASE.TIME_OUT_CHK]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR},
  [PHASE.CANCEL]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR},
  [PHASE.FAILED]: { headerColor: HEADER_COLORS.DANGER, headerTitle: HEADER_TITLES.ERROR},
};
